import { useLocalStorage } from "./useLocalStorage";

export const useSavedActiveOnly = (): { activeOnly: boolean; setActiveOnly: (value: boolean) => void } => {
  const { activeOnly, setActiveOnly } = useLocalStorage();
  return { activeOnly, setActiveOnly };
};
